export default __webpack_public_path__ + "static/media/nograph.bc0fccb8.png";